import React, {Component} from 'react'
import CardGrid from '../CardGrid'
import './section-roster.css'

class SectionRoster extends Component {

  render() {
    let data = this.props.data;
    let images = this.props.images;

    return (
      <div className="section-roster-container">

        <div className="subsection-header-title">
          {data.title}
        </div>

        <br></br><br></br>
        <CardGrid
          height={this.props.height}
          data={data.members}
          images={images}
          nCellsPerRow={this.props.nCellsPerRow}
          nCellsPerRowMobile={this.props.nCellsPerRowMobile}></CardGrid>
      </div>
    );
  }
}

export default SectionRoster
